// ThriveSignaturePDF.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Link
} from '@react-pdf/renderer';

// Translated styles (based on your HTML/CSS)
const styles = StyleSheet.create({
  page: {
    maxWidth: '595px',
    fontSize: 10
  },
  header: {
    backgroundColor: '#f1f4ff',
    padding: "40px 40px 20px 40px",
    textAlign: 'center',
    marginBottom: 30,
    position: 'relative',
  },
  date: {
    position: 'absolute',
    top: 10,
    right: 20,
    fontSize: 10,
    color: "#444"
  },
  title: {
    fontSize: 18,
    color: '#222',
    marginTop: 20,
  },
  body: {
    paddingHorizontal: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 30,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    borderBottomStyle: 'solid',
  },
  label: {
    width: '40%',
    fontWeight: 'bold',
    color: '#000',
  },
  value: {
    width: '60%',
    color: '#444',
  },
  tag: {
    padding: "4px 12px",
    backgroundColor: '#e0e7ff',
    color: '#1a237e',
    paddingHorizontal: 6,
    height: 20,
    borderRadius: 6,
    fontWeight: 'bold'
  },
  agreementSection: {
    fontSize: 10,
    color: '#333',
    lineHeight: 1.5,
    marginTop: 40,
  },
  signatureLabel: {
    marginTop: 20,
    fontWeight: 'bold',
    color: "#000"
  },
  signatureImage: {
    marginTop: 10,
    width: 200,
    height: 60,
  },
});

const ThriveSignaturePDF = ({ formData = {}, formFields = [] }) => {
  console.log(formData?.signature, "formData")
  const foundDate = formData.created_at || formData.createdAt;
  const formattedDate = foundDate
    ? new Date(foundDate).toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
    : '-';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.date}><Text style={{ color: "#000", fontWeight: 'bold' }}>Submitted Date: </Text>{formattedDate}</Text>
          <Text style={styles.title}>Henry Schein Thrive Signature Enrollment Form</Text>
        </View>
        <View style={styles.body}>
          {formFields.map((field) => {
            const isTag = ['title', 'subscription_plan', 'state'].includes(field.key);
            const value = formData[field.key] || '-';

            return (
              <View style={styles.row} key={field.key}>
                <Text style={styles.label}>{field.label}</Text>
                <Text style={[styles.value, isTag && styles.tag]}>{value}</Text>
              </View>
            );
          })}

          <View style={styles.agreementSection}>
            <Text>
              By clicking the <Text style={{ fontWeight: 'bold', color: '#000' }}>"Enroll"</Text> button below, you agree: (i) to place this order and agree to the related terms electronically, and (ii) to the terms and conditions of the{' '}
              <Link src={formData?.thrivesignatureLink}>Thrive Signature Service Agreement</Link>.
            </Text>
            <Text style={{ margin: '5px 0px' }}></Text>
            <Text>
              Placing this order also includes your acceptance and agreement to our program{' '}
              <Link src={formData?.thrivesignaturetermconditionLink}>Terms and Conditions</Link>. Please read them before placing this order.
            </Text>
            <Text style={styles.signatureLabel}>Signature:</Text>
            {formData.signaturebase64 && <Image style={styles.signatureImage} src={formData.signaturebase64} />}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ThriveSignaturePDF;
